
import { Component, Vue } from "vue-property-decorator";
import YesIcon from "@/components/Icons/YesIcon.vue";
import NoIcon from "@/components/Icons/NoIcon.vue";

@Component({
    components:{
        YesIcon,
        NoIcon
    }
})
export default class BonusList extends Vue {

};
